// Adresses et paramètres: tout ce que la passerelle locale doit savoir lire dans
// une requête axios, sans jamais dépendre de l'écran qui l'a émise.

const PARAMETRES_DE_PAGE = new Set([
  'page', 'page_size', 'limit', 'offset', 'skip', 'include_total', 'sort', 'order',
  'sort_by', 'order_by', 'cursor', 'per_page', 'size',
]);
const PARAMETRES_DE_RECHERCHE = new Set(['q', 'search', 'query', 'term']);

export const estParametreDePage = (nom) => PARAMETRES_DE_PAGE.has(nom);
export const estParametreDeRecherche = (nom) => PARAMETRES_DE_RECHERCHE.has(nom);

const lireRequete = (texte) => {
  const resultat = {};
  if (!texte) return resultat;
  new URLSearchParams(texte).forEach((valeur, cle) => {
    resultat[cle] = valeur;
  });
  return resultat;
};

/**
 * Découpe l'adresse d'une requête axios en `{ chemin, parametres }`.
 * Le chemin est relatif à l'API (`/orders/abc`), sans barre finale ni requête.
 */
export function decouperAdresse(config) {
  let url = String(config?.url || '');
  const base = String(config?.baseURL || '');
  if (base && url.startsWith(base)) url = url.slice(base.length);
  else {
    const marque = url.indexOf('/api/v1');
    if (marque >= 0) url = url.slice(marque + '/api/v1'.length);
  }
  const [brut, requete] = url.split('#')[0].split('?');
  let chemin = `/${brut.replace(/^\/+/, '').replace(/\/+$/, '')}`;
  if (chemin === '/') chemin = '/';
  const parametres = { ...lireRequete(requete), ...(config?.params || {}) };
  Object.keys(parametres).forEach((cle) => {
    const valeur = parametres[cle];
    if (valeur === undefined || valeur === null || valeur === '') delete parametres[cle];
  });
  return { chemin, parametres };
}

/** Forme canonique d'un jeu de paramètres: clés triées, valeurs en texte. */
export function parametresCanoniques(parametres) {
  const cles = Object.keys(parametres || {}).sort();
  return cles
    .map((cle) => {
      const valeur = parametres[cle];
      return `${cle}=${Array.isArray(valeur) ? valeur.join(',') : String(valeur)}`;
    })
    .join('&');
}

export const cleDeLecture = (chemin, parametres) => {
  const canon = parametresCanoniques(parametres);
  return canon ? `${chemin}?${canon}` : chemin;
};

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
export const estIdentifiant = (segment) =>
  Boolean(segment) && (UUID.test(segment) || /^[A-Za-z0-9_-]{16,}$/.test(segment) || /^\d+$/.test(segment));

/** `/orders/abc` -> `{ parent: '/orders', id: 'abc' }`, sinon null. */
export function separerDernierSegment(chemin) {
  const index = chemin.lastIndexOf('/');
  if (index <= 0) return null;
  return { parent: chemin.slice(0, index), id: decodeURIComponent(chemin.slice(index + 1)) };
}

export const copie = (valeur) => {
  if (valeur === undefined) return undefined;
  if (typeof structuredClone === 'function') {
    try {
      return structuredClone(valeur);
    } catch (erreur) {
      // retombe sur JSON
    }
  }
  return JSON.parse(JSON.stringify(valeur));
};

export const nouvelIdentifiant = () => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  const hex = () => Math.floor(Math.random() * 0x10000).toString(16).padStart(4, '0');
  return `${hex()}${hex()}-${hex()}-4${hex().slice(1)}-a${hex().slice(1)}-${hex()}${hex()}${hex()}`;
};
